import { type ReactNode } from 'react'
import i18n from '@/i18n'
import baseSource from './base.copy?raw'
import { parseCopyVariant } from './parseCopyVariant'

// Parsed canonical content. The only copy resource that ships in production.
export const BASE_VARIANT = parseCopyVariant(baseSource, 'base.copy')

if (import.meta.env.DEV && BASE_VARIANT.warnings.length > 0) {
  console.warn(`[Copy] base.copy warnings:\n  ${BASE_VARIANT.warnings.join('\n  ')}`)
}

// Apply at module init so the first render uses the canonical copy.
i18n.addResourceBundle('en', 'common', BASE_VARIANT.resources.common, true, true)
i18n.addResourceBundle('en', 'lorem', BASE_VARIANT.resources.lorem, true, true)

export function CopyContentProvider({ children }: { children: ReactNode }) {
  return <>{children}</>
}
